/* eslint-disable */

export default {
  init() {
    const data =
      "<!-- Google Tag Manager --><script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);    })(window,document,'script','dataLayer','GTM-TVXH497');</script>    <!-- End Google Tag Manager -->";
    var script = document.createElement("script");
    //script.type = "application/ld+json";
    script.innerHTML = data;
    document.getElementsByTagName("head")[0].appendChild(script);

    const bodyData =
      '<!-- Google Tag Manager (noscript) -->    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TVXH497"    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>    <!-- End Google Tag Manager (noscript) -->';
    var script = document.createElement("script");
    //script.type = "application/ld+json";
    script.innerHTML = bodyData;
    document.getElementsByTagName("body")[0].appendChild(script);

    if (window.location.href.search("/thanks/") > 0) {
      $(".contact-information").css("display", "none");
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateTemplateThankYou.js